import { ReactComponent as Pending } from 'assett/icons/timeline_pending_icon.svg';
import { ReactComponent as Reject } from 'assett/icons/timeline_reject_icon.svg';
import { ReactComponent as Submit } from 'assett/icons/timeline_submit_icon.svg';
import { ReactComponent as Upload } from 'assett/icons/timeline_upload_icon.svg';
import { Box } from 'styles';
import { HISTORY_TYPES, IHistoryItem } from 'types/History';

type Props = {
	item: IHistoryItem;
	isLast?: boolean;
};

const HistoryItemIcon = ({ item, isLast }: Props) => {
	const getHistoryItemIcon = () => {
		if (item.typeHistory === HISTORY_TYPES.ATTACHMENT) {
			return <Upload width={24} height={24} />;
		}

		if (item.typeHistory === HISTORY_TYPES.BILLING) {
			switch (item.id) {
				case 1:
					return <Pending width={24} height={24} />;
				case 2:
				case 3:
					return <Submit width={24} height={24} />;
				case 4:
					return <Upload width={24} height={24} />;
				case 5:
				case 6:
					return <Reject width={24} height={24} />;
				default:
					return <Pending width={24} height={24} />;
			}
		}

		if (item.typeHistory === HISTORY_TYPES.FRAUD) {
			switch (item.investigationStatusCode) {
				case 'OPEN':
				case 'UNDER_INVESTIGATION':
					return <Submit width={24} height={24} />;
				case 'CLOSED':
					return <Upload width={24} height={24} />;
				default:
					return <Pending width={24} height={24} />;
			}
		}

		if (item.typeHistory === HISTORY_TYPES.COMPLAINT) {
			if (item.statusCode) {
				switch (item.statusCode) {
					case 'OPEN':
					case 'IN_PROGRESS':
						return <Submit width={24} height={24} />;
					case 'RESOLVED':
						return <Upload width={24} height={24} />;
					case 'CANCELED_MEMBER_REQUEST':
					case 'CANCELED_ENTERED_IN_ERROR':
						return <Reject width={24} height={24} />;
					default:
						return <Pending width={24} height={24} />;
				}
			}

			if (item.typeCode) {
				switch (item.typeCode) {
					case 'FORMAL':
					case 'INFORMAL':
					case 'FORMAL_WITH_REGULATOR_INVOLVEMENT':
						return <Submit width={24} height={24} />;
					default:
						return <Pending width={24} height={24} />;
				}
			}

			if (item.outcomeCode) {
				switch (item.outcomeCode) {
					case 'UPHELD':
					case 'PARTIALLY_UPHELD':
					case 'WITHDRAWN':
					case 'OTHER':
						return <Upload width={24} height={24} />;
					case 'NOT_UPHELD':
						return <Reject width={24} height={24} />;
					case 'PENDING_DECISION':
						return <Pending width={24} height={24} />;
					default:
						return <Pending width={24} height={24} />;
				}
			}
		}

		switch (item.id) {
			case 1:
			case 13:
			case 16:
			case 17:
			case 18:
			case 19:
				return <Pending width={24} height={24} />;
			case 3:
			case 10:
			case 11:
			case 12:
				return <Submit width={24} height={24} />;
			case 4:
			case 5:
			case 9:
				return <Upload width={24} height={24} />;
			case 2:
			case 7:
			case 8:
			case 14:
			case 15:
				return <Reject width={24} height={24} />;

			default:
				return <Pending width={24} height={24} />;
		}
	};

	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			alignItems={'center'}
			position={'relative'}
			width="24px"
		>
			<Box
				display={'flex'}
				width={'1px'}
				flex={isLast ? 0.5 : 1}
				minHeight={'5px'}
				backgroundColor={'grey4.main'}
			/>
			{getHistoryItemIcon()}
			{!isLast && (
				<Box
					display={'flex'}
					width={'1px'}
					flex={1}
					minHeight={'5px'}
					backgroundColor={'grey4.main'}
				/>
			)}
		</Box>
	);
};

export default HistoryItemIcon;
